import { render, staticRenderFns } from "./AppliedPostprocessing.vue?vue&type=template&id=fb22219e&scoped=true&"
import script from "./AppliedPostprocessing.vue?vue&type=script&lang=js&"
export * from "./AppliedPostprocessing.vue?vue&type=script&lang=js&"
import style0 from "./AppliedPostprocessing.vue?vue&type=style&index=0&id=fb22219e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb22219e",
  null
  
)

export default component.exports